export default "__VITE_ASSET__d5069058__"